import { MeasurementsFormData } from 'src/Libs/installation-statement/models/measurements'

export const DEFAULT_MEASUREMENTS_DATA: Readonly<MeasurementsFormData> = {
  measurementDeviceManufacturer: '',
  measurementDeviceType: '',
  loopImpedanceNL1: null,
  loopImpedanceNL2: null,
  loopImpedanceNL3: null,
  loopImpedancePEL: null,
}
